'use strict'

//Globals
import Footer from './global/footer'
import Header from './global/header'

export default class AppGlobal {
    constructor() {
        const HeaderElement = document.querySelector('.header-main')
        const FooterElement = document.querySelector('.main-footer')

        HeaderElement ? new Header() : null
        FooterElement ? new Footer() : null
    }
}

new AppGlobal()